import Loader from "./Loader";
import Parser from "./Parser";
export function loadAndParseFromUrl(url) {
    return new Promise(function (resolve, reject) {
        var loader = new Loader();
        loader.load(url).then(function (dicomBuffer) {
            if (!dicomBuffer) {
                reject('Error on loading file!');
                return;
            }
            var parser = new Parser(dicomBuffer);
            var dataset = parser.getDataset();
            if (!dataset) {
                reject('Error on parsing data');
                return;
            }
            resolve(dataset);
        });
    });
}
export function loadAndParseFromFiles(file) {
    return new Promise(function (resolve, reject) {
        var loader = new Loader();
        loader.load(file).then(function (dicomBuffer) {
            if (!dicomBuffer) {
                reject('Error on loading file!');
                return;
            }
            var parser = new Parser(dicomBuffer);
            var dataset = parser.getDataset();
            if (!dataset) {
                reject('Error on parsing data');
                return;
            }
            resolve(dataset);
        });
    });
}
export function parse(dicomBuffer) {
    var parser = new Parser(dicomBuffer);
    var dataset = parser.getDataset();
    return dataset;
}
export default {
    parse: parse,
    loadAndParseFromFiles: loadAndParseFromFiles,
    loadAndParseFromUrl: loadAndParseFromUrl,
};
